// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__xZWQm","footer":"ModalInfo_footer__G356k"};